import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["href"]
const _hoisted_3 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('imprint.headline')), 1),
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('imprint.company.name')), 1),
                        _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('imprint.company.streetAddress')), 1),
                        _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('imprint.company.address')), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('general.telephone.title.short')) + ": " + _toDisplayString(_ctx.$t('imprint.company.telephone')), 1),
                        _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('general.email.title')) + ": ", 1),
                        _createElementVNode("a", {
                          href: 'mailto:' + _ctx.$t('general.email.content')
                        }, _toDisplayString(_ctx.$t('general.email.content')), 9, _hoisted_1),
                        _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('general.internet')) + ": ", 1),
                        _cache[4] || (_cache[4] = _createElementVNode("a", { href: "https://www.spitpaslode.be/be/" }, "www.spitpaslode.be", -1))
                      ]),
                      _createElementVNode("p", null, [
                        _createElementVNode("b", null, _toDisplayString(_ctx.$t('imprint.company.managingDirector.headline')), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('imprint.company.managingDirector.name')), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('imprint.company.court.name')), 1),
                        _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('imprint.company.court.id')), 1),
                        _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('imprint.company.court.taxNumber')), 1),
                        _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('imprint.company.court.responsibility')), 1)
                      ]),
                      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('imprint.company.conciliationProceedings.headline')) + ":", 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('imprint.company.conciliationProceedings.content.intro')), 1),
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('imprint.company.conciliationProceedings.content.osPlatform.title')) + ": ", 1),
                        _createElementVNode("a", {
                          href: _ctx.$t('general.conciliationProceedings.osPlatform.link')
                        }, _toDisplayString(_ctx.$t('general.conciliationProceedings.osPlatform.link')), 9, _hoisted_2),
                        _cache[8] || (_cache[8] = _createTextVNode(".", -1))
                      ]),
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('imprint.company.conciliationProceedings.content.osPlatform.email.title')) + ": ", 1),
                        _createElementVNode("a", {
                          href: 'mailto:' + _ctx.$t('general.email.content')
                        }, _toDisplayString(_ctx.$t('general.email.content')), 9, _hoisted_3)
                      ]),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('imprint.company.conciliationProceedings.content.outro')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}